import { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireLinkClickedEvent } from '../../utils/analytics/click';
var useMouseDownEvent = function useMouseDownEvent(onMouseDown) {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  return useCallback(function (event) {
    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);

    // ignore left clicks
    // these would be handled by `onClick` handler instead
    if (event.button !== 0) {
      fireLinkClickedEvent(createAnalyticsEvent)(event);
    }
  }, [onMouseDown, createAnalyticsEvent]);
};
export default useMouseDownEvent;